module.exports=function(scope){ return `<!-- enrollmentIdentifier or FaceMap or image missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "This endpoint requires valid 'enrollmentIdentifier' or 'faceMap' or 'image' parameters to be passed.",
        "subCode": "missingParameter"
    }
}

<!-- sessionId missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "The request is missing the sessionId parameter. The sessionId parameter is required and can be obtained from the output of the FaceTec iOS/Android/Browser SDK. For more information, please visit https://dev.facetec.com/zoomsdk/#/webservice-guide.",
        "subCode": "missingParameter"
    }
}

<!-- targetAge missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "The request is missing the targetAge parameter. The targetAge parameter is required. For more information, please visit https://dev.facetec.com/zoomsdk/#/webservice-guide.",
        "subCode": "missingParameter"
    }
}

<!-- Invalid sessionId -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "sessionId must be UUID in standard format.",
        "subCode": "invalidSessionId"
    }
}

<!-- empty enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter enrollmentIdentifier",
        "subCode": "badStringParameter"
    }
}

<!-- empty faceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter FaceMap.",
        "subCode": "badStringParameter"
    }
}

<!-- empty image -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter image.",
        "subCode": "badStringParameter"
    }
}

<!-- invalid enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "One of the enrollmentIdentifier values was invalid. An enrollmentIdentifier must be a non-empty alphanumeric string. Underscores, hyphens, and emails are also allowed.",
        "subCode": "invalidName"
    }
}

<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "No entry found in the database for this enrollmentIdentifier.",
        "subCode": "targetNotFound"
    }
}

<!-- enrollmentIdentifier must be up to 63 characters-->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Please provide up to 63 characters for enrollmentIdentifier.",
        "subCode": "invalidName"
    }
}

<!-- faceMap or image is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Source data length is < 20.",
        "subCode": "unableToProcess"
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/failure/age-check.json.tpl